import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getNoviStructuredData() {
  const url = "https://restorehair.com/locations/michigan/novi/";
  const description =
    "Find out about your hair transplant options in Novi with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("novi", url, description),
    locationPageCrumbs(url, "Novi"),
  ];
}
